import { render, staticRenderFns } from "./Metric.vue?vue&type=template&id=68a1b2c7&scoped=true&"
import script from "./Metric.vue?vue&type=script&lang=js&"
export * from "./Metric.vue?vue&type=script&lang=js&"
import style0 from "./Metric.vue?vue&type=style&index=0&id=68a1b2c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a1b2c7",
  null
  
)

export default component.exports